import * as IF from "infrontjs";
import template from "./template.html";

// Register the custom elements used inside the shell.
import "../bottom-nav";
import "../top-menu";
import "../menu-drawer";
import "../weather-sheet";

/**
 * <app-layout> — the Guest App shell.
 *
 * Renders the phone-column shell (scrolling content slot + bottom tab bar +
 * menu drawer + weather sheet) when a guest is signed in, or an empty
 * #main-wrapper for the full-screen auth states when not. The View decides which
 * by re-rendering after the auth state changes (mirrors the saas-admin shell).
 */
class AppLayout extends HTMLElement
{
    constructor()
    {
        super();
        this._connected = false;
    }

    connectedCallback()
    {
        if ( false === this._connected )
        {
            this.app = IF.App.get();
            this.render();
            this._connected = true;
        }
    }

    render()
    {
        this.app.view.render( this, template, { user: this.app.user } );
    }
}

customElements.define( "app-layout", AppLayout );
